export enum EQUIPEMENT {
    SET_NON_PREVENTIVE_STATS = 'SET_NON_PREVENTIVE_STATS',
    SET_PREVENTIVE_STATS_CIRCLE = 'SET_PREVENTIVE_STATS_CIRCLE',
    SET_PREVENTIVE_STATS_CHART = 'SET_PREVENTIVE_STATS_CHART',

    SET_DEVIS_STATS = 'SET_DEVIS_STATS',
    SET_DEMANDES_INTERVENTION_STATS = 'SET_DEMANDES_INTERVENTION_STATS',
    SET_NON_PREVENTIVE_STATS_LOADING = 'SET_NON_PREVENTIVE_STATS_LOADING',
    SET_PREVENTIVE_STATS_CIRCLE_LOADING = 'SET_PREVENTIVE_STATS_CIRCLE_LOADING',
    SET_PREVENTIVE_STATS_CHART_LOADING = 'SET_PREVENTIVE_STATS_CHART_LOADING',
    SET_DEVIS_STATS_LOADING = 'SET_DEVIS_STATS_LOADING',
    SET_DEMANDES_INTERVENTION_STATS_LOADING = 'SET_DEMANDES_INTERVENTION_STATS_LOADING',
    SET_LOADING = 'SET_LOADING',
    SET_ERROR = 'SET_ERROR',
    SET_DETAILS_EQUIPEMENT = 'SET_DETAILS_EQUIPEMENT',
    SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',

    //Historique Demandes interventions
    HISTORIQUE_DEMANDE_INTERVENTION_SET_ITEMS = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_ITEMS',
    HISTORIQUE_DEMANDE_INTERVENTION_RESET_ITEMS = 'HISTORIQUE_DEMANDE_INTERVENTION_RESET_ITEMS',
    HISTORIQUE_DEMANDE_INTERVENTION_ADD_ITEMS = 'HISTORIQUE_DEMANDE_INTERVENTION_ADD_ITEMS',

    HISTORIQUE_DEMANDE_INTERVENTION_SET_PAGE = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_PAGE',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_NB_OF_PAGES = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_NB_OF_PAGES',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_SCROLL = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_SCROLL',

    HISTORIQUE_DEMANDE_INTERVENTION_SET_SORT = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_SORT',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_STATUS = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_STATUS',
    HISTORIQUE_DEMANDE_INTERVENTION_RESET_FILTER = 'HISTORIQUE_DEMANDE_INTERVENTION_RESET_FILTER',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_DEMANDE_INTERVENTION_ID = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_DEMANDE_INTERVENTION_ID',

    HISTORIQUE_DEMANDE_INTERVENTION_ADD_FILTER_STATUS = 'HISTORIQUE_DEMANDE_INTERVENTION_ADD_FILTER_STATUS',
    HISTORIQUE_DEMANDE_INTERVENTION_REMOVE_FILTER_STATUS = 'HISTORIQUE_DEMANDE_INTERVENTION_REMOVE_FILTER_STATUS',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_COUNT = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_COUNT',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_FROM = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_FROM',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_TO = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_TO',

    HISTORIQUE_DEMANDE_INTERVENTION_SET_IS_LOADING = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_IS_LOADING',
    HISTORIQUE_DEMANDE_INTERVENTION_SET_ERROR = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_ERROR',

    HISTORIQUE_DEMANDE_INTERVENTION_CLEAR_ALL = 'HISTORIQUE_DEMANDE_INTERVENTION_CLEAR_ALL',

    HISTORIQUE_DEMANDE_INTERVENTION_SET_EXPORT_XLS_IS_LOADING = 'HISTORIQUE_DEMANDE_INTERVENTION_SET_EXPORT_XLS_IS_LOADING',

    // Historique Travaux
    HISTORIQUE_TRAVAUX_SET_ITEMS = 'HISTORIQUE_TRAVAUX_SET_ITEMS',
    HISTORIQUE_TRAVAUX_ADD_ITEMS = 'HISTORIQUE_TRAVAUX_ADD_ITEMS',
    HISTORIQUE_TRAVAUX_SET_PAGE = 'HISTORIQUE_TRAVAUX_SET_PAGE',
    HISTORIQUE_TRAVAUX_SET_NB_OF_PAGES = 'HISTORIQUE_TRAVAUX_SET_NB_OF_PAGES',
    HISTORIQUE_TRAVAUX_SET_COUNT = 'HISTORIQUE_TRAVAUX_SET_COUNT',
    HISTORIQUE_TRAVAUX_SET_SORT = 'HISTORIQUE_TRAVAUX_SET_SORT',
    HISTORIQUE_TRAVAUX_SET_IS_LOADING = 'HISTORIQUE_TRAVAUX_SET_IS_LOADING',

    HISTORIQUE_TRAVAUX_ADD_FILTER_STATUS = 'HISTORIQUE_TRAVAUX_ADD_FILTER_STATUS',
    HISTORIQUE_TRAVAUX_REMOVE_FILTER_STATUS = 'HISTORIQUE_TRAVAUX_REMOVE_FILTER_STATUS',
    HISTORIQUE_TRAVAUX_SET_FILTER_STATUS = 'HISTORIQUE_TRAVAUX_SET_FILTER_STATUS',
    HISTORIQUE_TRAVAUX_SET_FILTER_INTERVENTION_ID = 'HISTORIQUE_TRAVAUX_SET_FILTER_INTERVENTION_ID',
    HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_FROM = 'HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_FROM',
    HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_TO = 'HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_TO',
    HISTORIQUE_TRAVAUX_RESET_FILTER = 'HISTORIQUE_TRAVAUX_RESET_FILTER',

    HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING = 'HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING',

    //Interventions preventives
    INTERVENTIONS_PREVENTIVES_SET_ITEMS = 'INTERVENTIONS_PREVENTIVES_SET_ITEMS',
    INTERVENTIONS_PREVENTIVES_ADD_ITEMS = 'INTERVENTIONS_PREVENTIVES_ADD_ITEMS',
    INTERVENTIONS_PREVENTIVES_SET_PAGE = 'INTERVENTIONS_PREVENTIVES_SET_PAGE',
    INTERVENTIONS_PREVENTIVES_SET_NB_OF_PAGES = 'INTERVENTIONS_PREVENTIVES_SET_NB_OF_PAGES',
    INTERVENTIONS_PREVENTIVES_SET_COUNT = 'INTERVENTIONS_PREVENTIVES_SET_COUNT',
    INTERVENTIONS_PREVENTIVES_SET_SORT = 'INTERVENTIONS_PREVENTIVES_SET_SORT',
    INTERVENTIONS_PREVENTIVES_SET_IS_LOADING = 'INTERVENTIONS_PREVENTIVES_SET_IS_LOADING',

    INTERVENTIONS_PREVENTIVES_ADD_FILTER_STATUS = 'INTERVENTIONS_PREVENTIVES_ADD_FILTER_STATUS',
    INTERVENTIONS_PREVENTIVES_REMOVE_FILTER_STATUS = 'INTERVENTIONS_PREVENTIVES_REMOVE_FILTER_STATUS',
    INTERVENTIONS_PREVENTIVES_SET_FILTER_STATUS = 'INTERVENTIONS_PREVENTIVES_SET_FILTER_STATUS',
    INTERVENTIONS_PREVENTIVES_SET_FILTER_INTERVENTION_ID = 'INTERVENTIONS_PREVENTIVES_SET_FILTER_INTERVENTION_ID',
    INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_FROM = 'INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_FROM',
    INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_TO = 'INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_TO',
    INTERVENTIONS_PREVENTIVES_RESET_FILTER = 'INTERVENTIONS_PREVENTIVES_RESET_FILTER',

    INTERVENTIONS_PREVENTIVES_SET_EXPORT_XLS_IS_LOADING = 'INTERVENTIONS_PREVENTIVES_SET_EXPORT_XLS_IS_LOADING',

    //HISTORIQUE-DEVIS
    DEVIS_SET_ITEMS = 'SET_DEVIS_ITEMS',
    DEVIS_ADD_ITEMS = 'ADD_DEVIS_ITEMS',
    DEVIS_SET_ITEM = 'SET_DEVIS_ITEM',
    DEVIS_RESET_ITEMS = 'RESET_DEVIS_ITEMS',

    DEVIS_SET_PAGE = 'SET_DEVIS_PAGE',
    DEVIS_SET_NB_OF_PAGES = 'SET_DEVIS_NB_OF_PAGES',
    DEVIS_SET_SCROLL = 'SET_DEVIS_SCROLL',

    DEVIS_SET_SORT = 'SET_DEVIS_SORT',
    DEVIS_RESET_FILTER = 'DEVIS_RESET_FILTER',
    DEVIS_SET_FILTER_DEVIS_ID = 'DEVIS_SET_FILTER_DEVIS_ID',
    DEVIS_SET_FILTER_DEVIS_NUMERO_COMMANDE = 'DEVIS_SET_FILTER_DEVIS_NUMERO_COMMANDE',
    DEVIS_SET_FILTER_DEVIS_NUM_FACTURE = 'DEVIS_SET_FILTER_DEVIS_NUM_FACTURE',
    DEVIS_ADD_FILTER_STATUS = 'DEVIS_ADD_FILTER_STATUS',
    DEVIS_REMOVE_FILTER_STATUS = 'DEVIS_REMOVE_FILTER_STATUS',
    DEVIS_SET_FILTER_STATUS = 'DEVIS_SET_FILTER_STATUS',
    DEVIS_SET_COUNT = 'DEVIS_SET_COUNT',

    DEVIS_SET_IS_LOADING = 'SET_DEVIS_IS_LOADING',
    DEVIS_SET_ERROR = 'SET_DEVIS_ERROR',

    DEVIS_CLEAR_ALL = 'DEVIS_CLEAR_ALL',

    DEVIS_ADD_BONCOMMANDE = 'DEVIS_ADD_BONCOMMANDE',
    DEVIS_REMOVE_BONCOMMANDE = 'DEVIS_REMOVE_BONCOMMANDE',

    DEVIS_SET_EXPORT_XLS_IS_LOADING = 'SET_HISTORIQUE_DEVIS_EXPORT_XLS_IS_LOADING',

    //Caracterisitiques et Maintenances
    SET_CARACTERISTIQUES_EQUIPEMENT = 'SET_CARACTERISTIQUES_EQUIPEMENT',
    SET_IS_CARACTERISTIQUES_LOADING = 'SET_IS_CARACTERISTIQUES_LOADING',
    SET_OPERATION_MAINTENANCE = 'SET_OPERATION_MAINTENANCE',
    SET_IS_OPERATION_MAINTENANCE_LOADING = 'SET_IS_OPERATION_MAINTENANCE_LOADING',

    //Document règlementaires
    DOCUMENT_REGLEMENTAIRE_SET_ITEMS = 'DOCUMENT_REGLEMENTAIRE_SET_ITEMS',
    DOCUMENT_REGLEMENTAIRE_ADD_ITEMS = 'DOCUMENT_REGLEMENTAIRE_ADD_ITEMS',
    DOCUMENT_REGLEMENTAIRE_SET_ADR_ITEMS = 'DOCUMENT_REGLEMENTAIRE_SET_ADR_ITEMS',
    DOCUMENT_REGLEMENTAIRE_ADD_ADR_ITEMS = 'DOCUMENT_REGLEMENTAIRE_ADD_ADR_ITEMS',
    DOCUMENT_REGLEMENTAIRE_SET_PEC_ITEMS = 'DOCUMENT_REGLEMENTAIRE_SET_PEC_ITEMS',
    DOCUMENT_REGLEMENTAIRE_RESET_ITEMS = 'DOCUMENT_REGLEMENTAIRE_RESET_ITEMS',

    DOCUMENT_REGLEMENTAIRE_SET_PAGE = 'DOCUMENT_REGLEMENTAIRE_SET_PAGE',
    DOCUMENT_REGLEMENTAIRE_SET_NB_OF_PAGES = 'DOCUMENT_REGLEMENTAIRE_SET_NB_OF_PAGES',
    DOCUMENT_REGLEMENTAIRE_SET_SCROLL = 'DOCUMENT_REGLEMENTAIRE_SET_SCROLL',

    DOCUMENT_REGLEMENTAIRE_SET_FILTER_DOCUMENT_TYPE = 'DOCUMENT_REGLEMENTAIRE_SET_FILTER_DOCUMENT_TYPE',

    DOCUMENT_REGLEMENTAIRE_SET_SORT = 'DOCUMENT_REGLEMENTAIRE_SET_SORT',
    DOCUMENT_REGLEMENTAIRE_SET_SORT_ADR = 'DOCUMENT_REGLEMENTAIRE_SET_SORT_ADR',
    DOCUMENT_REGLEMENTAIRE_SET_COUNT = 'DOCUMENT_REGLEMENTAIRE_SET_COUNT',
    DOCUMENT_REGLEMENTAIRE_SET_COUNT_FOR_MODAL = 'DOCUMENT_REGLEMENTAIRE_SET_COUNT_FOR_MODAL',

    DOCUMENT_REGLEMENTAIRE_SET_ERROR = 'DOCUMENT_REGLEMENTAIRE_SET_ERROR',
    DOCUMENT_REGLEMENTAIRE_SET_IS_LOADING = 'DOCUMENT_REGLEMENTAIRE_SET_IS_LOADING',
    DOCUMENT_REGLEMENTAIRE_SET_ZIP_IS_LOADING = 'DOCUMENT_REGLEMENTAIRE_SET_ZIP_IS_LOADING',

    DOCUMENT_REGLEMENTAIRE_RESET = 'DOCUMENT_REGLEMENTAIRE_RESET',

    DOCUMENTS_REGLEMENTAIRES_SET_TYPES = 'DOCUMENTS_REGLEMENTAIRES_SET_TYPES',
    DOCUMENT_REGLEMENTAIRE_SET_LIST_TYPES_IS_LOADING = 'DOCUMENT_REGLEMENTAIRE_SET_LIST_TYPES_IS_LOADING',
}
